module.exports = __webpack_public_path__ + "static/new-logo-f769ca8c3babaa8fe9fe2357b6813633.png";